import { render, staticRenderFns } from "./GNumberForm.vue?vue&type=template&id=f8a18c9e&"
import script from "./GNumberForm.vue?vue&type=script&lang=ts&"
export * from "./GNumberForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports